import { createSlice, PayloadAction } from '@reduxjs/toolkit';
// import { MeResponse } from 'signature-public-api-sdk';
import { User } from '../../types/User';
import { AuthState, LoginSuccessPayload } from './auth-types';

const initialState: AuthState = {
    tokenExpired: true,
    requestingLogin: false,
    requestingLoginFailed: false,
    requestingValidateAuthCookie: false,
    sessionTimeout: false,
};

const slice = createSlice({
    name: 'auth',
    initialState,
    reducers: {
        requestLogin: state => ({
            ...state,
            requestingLogin: true,
            requestingLoginFailed: false,
            sessionTimeout: false,
        }),
        receiveLoginSuccess: (state, action: PayloadAction<LoginSuccessPayload>) => ({
            ...state,
            lastError: undefined,
            requestingLogin: false,
            tokenExpired: false,
            requestingLoginFailed: false,
        }),
        receiveLoginFailure: (state, action: PayloadAction<string>) => ({
            ...state,
            requestingLogin: false,
            requestingLoginFailed: true,
            loginError: action.payload,
        }),
        requestValidateAuthCookie: state => ({
            ...state,
            requestingValidateAuthCookie: true,
            requestingLogin: false,
        }),
        // eslint-disable-next-line
        receiveValidateAuthCookieSuccess: (state, action: PayloadAction<User>) => ({
            ...state,
            requestingValidateAuthCookie: false,
            tokenExpired: false,
            requestingLoginFailed: false,
            requestingLogin: false,
        }),
        receiveValidateAuthCookieFailure: (state, action: PayloadAction<string>) => ({
            ...state,
            requestingValidateAuthCookie: false,
            cookieError: action.payload,
            tokenExpired: true,
            requestingLogin: false,
        }),
        requestResetPassword: state => ({
            ...state,
            requestingResetPassword: true,
        }),
        receiveResetPasswordSuccess: state => ({
            ...state,
            requestingResetPassword: true,
        }),
        receiveResetPasswordFailure: state => ({
            ...state,
            requestingResetPassword: true,
        }),
        logout: () => initialState,
    },
});

export default slice;
export const { actions, reducer } = slice;
